import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './gynecologicHistory.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class GynecologicHistoryDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const menopauseStatus = isNullOrWhiteSpace(this.props.gynecologicHistory.menopauseStatusDisplay) ?
      this.props.gynecologicHistory.menopauseStatus :
      this.props.gynecologicHistory.menopauseStatusDisplay;
    const menopausalReason = isNullOrWhiteSpace(this.props.gynecologicHistory.menopausalReasonDisplay) ?
      this.props.gynecologicHistory.menopausalReason :
      this.props.gynecologicHistory.menopausalReasonDisplay;
    return (
      this.props.gynecologicHistory.isNullMessageHolder === false ?
      <div className="row item-row"
        data-qa={'gynecologicHistory_' + menopauseStatus}
      >
        <div className="col-md-4 primary-data">
          {
            this.props.gynecologicHistory.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {menopauseStatus}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              {
                // If a real date is provided, we want to render it out as an internationalizable date.
                // If not, we want to display the more generic text version (which may be blank/null).
                this.props.gynecologicHistory.lastMenstrualPeriod !== null ?
                <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.lastMenstrualPeriod} />}
                  value={this.props.gynecologicHistory.lastMenstrualPeriod} language={this.props.language} isDate
                  isActive={this.configurationActive('LastMenstrualPeriod')}
                /> :
                <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.lastMenstrualPeriod} />}
                  value={this.props.gynecologicHistory.lastMenstrualPeriodText} language={this.props.language}
                  isActive={this.configurationActive('LastMenstrualPeriod')}
                />
              }
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.menopausalReason} />}
                value={menopausalReason} language={this.props.language}
                isActive={this.configurationActive('MenopausalReason')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.gynecologicHistory.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="gynecologicHistory_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.gynecologicHistory.nullMessage}
        </div>
      </div>
    );
  }
}

GynecologicHistoryDetail.propTypes = {
  gynecologicHistory: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
